module.exports = __webpack_public_path__ + "media/73.793f60dd.mp3";